import Breadcrumb from "component/common/breadcrumb";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import strings from "translate/language";
import {
  getPrivacyPolicy,
  updatePrivacyPolicy,
} from "../../reduxStore/action/configurationSettingAction";
import Button from "../../component/Button";
import { handleDetailResponse, isEmpty, seo } from "../../utils/utils";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const PrivacyPolicyUpdate = () => {
  const dispatch = useDispatch();
  const [isModify, setIsModify] = useState(true);
  const [privacyData, setPrivacyData] = useState({});
  const [form, setForm] = useState({});

  const PrivacyPolicySelector =
    useSelector((state) => state.configurationSettingDetail) || {};

  useEffect(() => {
    const { create, result, detail } = PrivacyPolicySelector;
    if (detail && result) {
      setPrivacyData(handleDetailResponse(result?.data));
      setForm(handleDetailResponse(result?.data));
    }
    if (create && result) {
      dispatch(getPrivacyPolicy());
    }
  }, [PrivacyPolicySelector]);

  useEffect(() => {
    dispatch(getPrivacyPolicy());
  }, []);
  const handleEdit = () => {
    let params = { ...privacyData };
    params.policy_id = params._id;
    if (!isEmpty(params.text)) {
      setIsModify(true);
      dispatch(updatePrivacyPolicy(params));
    } else {
    }
  };

  useEffect(() => {
    seo({
      title: "Privacy Policy Edit",
      metaDescription: "Privacy policy edit",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.editPrivacyPolicy}
        // url={"/property"}
        // parentListing={strings.editPrivacyPolicy}
        titleactive={strings.editPrivacyPolicy}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header pb-0">
                <h5>{strings.editPrivacyPolicy}</h5>
              </div>
              <div
                className="card-body editor__editable_inline"
              // style={{ minHeight: 100 }}
              >
                <CKEditor
                  editor={ClassicEditor}
                  // style={{ height: 500 }}
                  disabled={isModify}
                  data={form?.text}
                  // onReady={(editor) => {
                  //   // You can store the "editor" and use when it is needed.
                  //   console.log("Editor is ready to use!", editor);
                  // }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    // console.log({ event, editor, data });
                    let obj = { ...privacyData };
                    obj.text = data;
                    setForm(obj);
                  }}
                // onBlur={(event, editor) => {
                //   console.log("Blur.", editor);
                // }}
                // onFocus={(event, editor) => {
                //   console.log("Focus.", editor);
                // }}
                />
                <div className="row">
                  <div className="col-md-12">
                    <div className="card-footer float-right">
                      <Button
                        className="btn btn-color mr-5"
                        onClick={() => setIsModify(!isModify)}
                        label={strings.modify}
                      ></Button>
                      <Button
                        disabled={isModify}
                        onClick={() => handleEdit()}
                        label={strings.update}
                      ></Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyUpdate;
